<template>
  <el-dialog
    :visible.sync="open"
    width="50%"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="status"
  >
    <div v-if="report" class="status__description">
      <div class="status__description-big">
        Добавить оплату по отчету № {{ report.id }} от {{ dateToFormat(report.created_at, 'onlyDateWithShortYear')}}
      </div>
      <div v-loading="loading">
        <div class="status__description-small">
          {{ report.name }}
        </div>
        <div class="status__description-small">
          {{ report.client_short_name }}
        </div>
        <div class="status__description-small">
          <span>{{ report.load_point && loadLocationFilter(report) }}</span>
          <span>
            ({{ report.load_point && report.load_point.split(',')[0] }})
          </span>
          <span class="mod-divider">-</span>
          <span>{{ report.cargo_receiver }}</span>
          <span>
              ({{ report.unload_point.split(',')[1].split(' ')[1] }})
            </span>
        </div>
        <div>
          {{ dateToFormat(report.dates.from, 'shortDateWithoutYear') }} -
          {{ dateToFormat(report.dates.to, 'shortDateWithoutYear') }}
        </div>
      </div>
    </div>
    <input
      v-model="addPaymentSum"
      type="number"
      placeholder="Введите сумму"
      class="status__input" />
    <span slot="footer">
      <el-button @click="closeModal">
        Отмена
      </el-button>
      <el-button
        type="primary"
        :disabled="addPaymentSum.length === 0"
        @click="setAddPayment"
      >
        Добавить оплату
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import shippingMixin from '@/mixins/shippingMixin'

const ReportsAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'PaymentModal',
  mixins: [shippingMixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      addPaymentSum: '',
      loading: false,
    }
  },
  methods: {
    // запрос на добавление оплаты
    async setAddPayment() {
      this.loading = true
      try {
        const response = await ReportsAPI.addPayment({
          total_report_id: this.report.id,
          sum: this.addPaymentSum,
        })

        this.$message.success('Оплата добавлена')
        this.$emit('payment-added')
      } catch (e) {
        this.errHandler(e)
      } finally {
        this.loading = false
      }
    },
    closeModal() {
      this.addPaymentSum = ''
      this.$emit('close-modal')
    },
  },
}
</script>

<style lang="sass" scoped>
@import "./modal-styles"
</style>
